import React from 'react';
import { AllowedGuard } from 'components/Tvendo/Common/UserAction';
import { ConstantPermissions } from 'contexts/useConstant';
import RegularButton from 'components/CustomButtons/Button';
import ReactTable from 'components/ReactTable/ReactTable';
import { Visibility } from '@material-ui/icons';
import Badge from 'components/Badge/Badge';
import { Link } from 'react-router-dom';
import { nDecimal } from 'hooks/Pipe';

const columns = [
  { Header: '#', accessor: 'num', width: 50 },
  { Header: 'Procesado', accessor: 'DeposId', width: 120, excelEnabled: false, align: 'center' },
  { Header: 'Tipo', accessor: 'DeposType', width: 80, align: 'center' },
  { Header: 'Fecha depósito', accessor: 'DeposDate', width: 150, align: 'center' },
  { Header: 'Banco', accessor: 'DpsBank', width: 150, align: 'center' },
  { Header: 'Cuenta deposito', accessor: 'BanckAcct', width: 150, align: 'center' },
  { Header: 'Moneda', accessor: 'DeposCurr', width: 90, align: 'center' },
  { Header: 'Monto', accessor: 'LocTotal', width: 150 },
  { Header: 'Descripición', accessor: 'Memo', width: 200 },
  { Header: 'Rerefencia', accessor: 'Ref2', width: 150, align: 'center' },
  { Header: 'Cuenta efectivo', accessor: 'AllocAcct', width: 150, align: 'center' },
  { Header: 'Método pago', accessor: 'U_SYP_MPPG', width: 150, align: 'center' },
  { Header: 'Usuario', accessor: 'oauth_user_id', width: 100, align: 'center' },
  { Header: 'Fecha creación', accessor: 'created_at', width: 150, align: 'center' },
  { Header: '', accessor: 'actions', excelEnabled: false, width: 0 },
];

function ClosingReceivedPayments({ data }) {
  return (
    <ReactTable
      columns={columns}
      defaultWidth={1900}
      formatDate="DD-MM-YYYY"
      data={data.map((item, i) => {
        return {
          ...item,
          num: (
            <div className="actions-right">
              {i + 1}
              <AllowedGuard permission={ConstantPermissions.PYMT_DEPOSITS_SHOW}>
                <Link to={`${item.id}`}>
                  <RegularButton justIcon round simple color="primary">
                    <Visibility />
                  </RegularButton>
                </Link>
              </AllowedGuard>
            </div>
          ),
          // Procesado
          DeposId:
            item.sapAnnuled !== null ? (
              <Badge color={item.sapAnnuled === 'P' ? 'warning' : 'danger'}>
                {item.sapAnnuled === 'P' ? 'Procesando anulación' : 'Anulado'}
              </Badge>
            ) : (
              <Badge color={item.DeposId === null ? 'warning' : 'success'}>
                {item.DeposId === null ? 'No' : 'Si'}
              </Badge>
            ),
          // DeposType
          DeposType: item.DeposType === 'C' ? 'Cash' : 'Cheque',
          LocTotal: nDecimal(item.LocTotal),
        };
      })}
    />
  );
}

export default ClosingReceivedPayments;
